/**
 * The match ID players, referees and admin screens share: `draw_match.draw_match_id`
 * (A1, qual-B2, C1), printed upper case. Every public surface prints it through here.
 */

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The stored ID upper-cased; null when missing or when a loader fell back to a uuid. */
export function displayMatchCode(id: string | null | undefined): string | null {
  const trimmed = id?.trim();
  if (!trimmed || UUID.test(trimmed)) return null;
  return trimmed.toUpperCase();
}

/** Without the qualifying prefix: the pool grid, whose heading already names the pool. */
export function shortMatchCode(id: string | null | undefined): string | null {
  return displayMatchCode(id)?.replace(/^QUAL-/, '') ?? null;
}
